import PlayerStatus from './PlayerStatus';

export default PlayerStatus;


// WEBPACK FOOTER //
// ./src/app/components/TableControls/PlayerStatus/index.js